export const STORAGE_KEYS = {
  MUST_CHANGE_PASSWORD: "must_change_password",
  LAST_CHECKOUT_SESSION: "last_checkout_session_id",
  AUTH_STORAGE: "auth-storage",
  /**
   * Drapeau `sessionStorage` signalant un onglet en impersonation. Tant qu'il est présent,
   * `auth.store` persiste le token dans `sessionStorage` (et non `localStorage`) — toute
   * opération qui vide `sessionStorage` doit donc le préserver avec `AUTH_STORAGE`.
   */
  IMPERSONATION_FLAG: "_imp",
  IMPERSONATION_INIT_PREFIX: "impersonation-init-",
  /** `sessionStorage` — build vers lequel l'onglet s'est déjà rechargé, garde anti-boucle. */
  BUILD_RELOAD_TARGET: "build-reload-target",
  /**
   * `sessionStorage` — date du dernier rechargement provoqué par un chunk introuvable.
   *
   * Un horodatage et non un drapeau : la garde doit empêcher une boucle de quelques secondes, pas
   * priver l'onglet de tout rechargement pour le reste de sa vie (cf. `vite:preloadError` dans
   * `main.tsx`).
   */
  CHUNK_RELOAD_AT: "chunk-reload-at",
  /**
   * `localStorage` — clé d'idempotence du checkout, liée à l'empreinte du panier :
   * `{ cartHash, key }`. Persistée (et non gardée en mémoire) pour qu'un rechargement
   * ou un réveil d'onglet entre deux tentatives de paiement ne fasse pas repartir un
   * POST /checkout avec une nouvelle clé — sinon le backend ne peut pas dédupliquer.
   * On n'y stocke que le hash + l'UUID, jamais le contenu du panier.
   */
  CHECKOUT_IDEMPOTENCY: "checkout_idempotency",
  LIVEKIT_DEVICE_ID: "livekit_device_id",
  /** Périphériques média choisis par l'utilisateur, réappliqués d'une session à l'autre. */
  LIVEKIT_AUDIO_INPUT: "livekit_audio_input",
  LIVEKIT_VIDEO_INPUT: "livekit_video_input",
  /** Horodatage ou statut de fermeture de la bannière A2HS (iOS Ajouter à l'écran d'accueil) */
  A2HS_POPUP_DISMISSED_AT: "a2hs_popup_dismissed_at",
  /**
   * `id` renvoyé par `POST /user/push-tokens` lors du dernier enregistrement — à conserver pour le
   * `DELETE` au logout (cf. `docs/PWA_PUSH_NOTIFICATIONS.md` §3.3).
   */
  PUSH_TOKEN_ID: "push_token_id",
  /**
   * Dernier jeton FCM effectivement envoyé au backend. Comparé au jeton courant à chaque démarrage
   * pour ne ré-`POST`er que sur changement (l'endpoint est idempotent, mais autant éviter l'appel).
   */
  PUSH_TOKEN_VALUE: "push_token_value",
  /** Horodatage ou statut de fermeture de la bannière post-connexion « Activer les notifications ». */
  PUSH_PROMPT_DISMISSED_AT: "push_prompt_dismissed_at",
  /** `"1"` si l'enseignant/admin a coupé le son joué à chaque main levée en classe live. */
  HAND_RAISE_SOUND_MUTED: "hand_raise_sound_muted",
} as const;

export const impersonationInitKey = (key: string) =>
  `${STORAGE_KEYS.IMPERSONATION_INIT_PREFIX}${key}`;
